import { Component, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';

@Component({
  selector: 'app-loyalty-rewards',
  templateUrl: './loyalty-rewards.component.html',
  styleUrls: ['./loyalty-rewards.component.scss']
})
export class LoyaltyRewardsComponent extends FeaturesBaseComponent implements OnInit {

  constructor() {
    super()
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
  ngOnDestroy() {
    super.ngOnDestroy();
  }

}
